export default __webpack_public_path__ + "static/media/sc50.764858dc.jpg";